module.exports = __webpack_public_path__ + "static/media/container11.282eb088.jpg";